// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"Job_pageContent__1Is6q","content":"Job_content__1BiBO"};